interface LatLngLiteralVerbose {
  latitude: number;
  longitude: number;
}
export type LatLngArray = [number, number];
export type LatLngString = string;

export type RoutesApiLatLngObj = {
  location: { latLng: LatLngLiteralVerbose };
};

export type LatLng = google.maps.LatLngLiteral | LatLngArray | LatLngString | LatLngLiteralVerbose;

export function toRouteLatLng(latLng: LatLng): RoutesApiLatLngObj {
  // If the latLng is an array i.e. is LatLngArray
  if (Array.isArray(latLng)) {
    return { location: { latLng: { latitude: latLng[0], longitude: latLng[1] } } };
  }

  // If latLng is string i.e. is LatLngString
  if (typeof latLng === 'string') {
    const latLngString = latLng.split(',');
    const latitude = parseFloat(latLngString[0]);
    const longitude = parseFloat(latLngString[1]);
    return { location: { latLng: { latitude, longitude } } };
  }

  // If latLng contains lat in it i.e. is LatLngLiteral
  if ('lat' in latLng) {
    return { location: { latLng: { latitude: latLng.lat, longitude: latLng.lng } } };
  }

  // If latLng contains lat in it i.e. is LatLngLiteralverbose
  return { location: { latLng } };
}

export const getAddressLines = (
  full_address: string,
  city: string
): { address1: string; address2: string } => {
  const arrayWithAddresses = full_address.split(',');
  const address1 = arrayWithAddresses[0];
  const address2Indx = arrayWithAddresses.findIndex((address) => address.includes(city));
  let address2 = '';

  for (let index = 1; index < address2Indx; index++) {
    address2 = address2 + arrayWithAddresses[index];
  }
  return { address1: address1, address2: address2 };
};

type MakeFullAddressParams = {
  address_1: string;
  address_2?: string | null;
  city: string;
  state: string;
  zip: string;
  country: string;
};

export const makeFullAddress = (params: MakeFullAddressParams): string => {
  const { address_1, address_2, city, state, zip, country } = params;
  return `${address_1}${address_2 ? ` ${address_2}` : ''}, ${city}, ${state} ${zip}, ${country}`;
};
